export default Object.freeze({
  DEFAULT: 'default',
  RDS: 'rds',
  AURORA: 'aurora',
  AZURE: 'azure',
  GCP: 'gcp',
  MARIA: 'maria',
  CLOUD: 'cloud',
  OAUTH: 'oauth',
  PAGES: 'pages',
});
